import React, { useState, useContext, useEffect, useRef } from "react";
import axios from "axios";
import { useSpring, animated } from "react-spring";

import { FormTextInput } from "../../Components/FormTextInput";

import { useScreenTransition } from "../../Hooks/useScreenTransition";

import { AuthContext } from "../../Context/AuthContext";
import { NotificationContext } from "../../Context/NotificationContext";
import { DataContext } from "../../Context/DataContext";

import TopBar from "../../Components/TopBar";
import SecureAndPrivate from "../../NewComponents/SecureAndPrivate";
import NewButton from "../../NewComponents/NewButton";
import CreateOrderNav from "../../NewComponents/CreateOrderNav";
import LogoAuthNavbar from "../../NewComponents/LogoAuthNavbar";
import OrderSummary from "./components/OrderSummary";
import { ReactComponent as ORDERSUCCESS } from "../../assets/icons/order-success.svg";

import {
  CardNumberElement,
} from "@stripe/react-stripe-js";
import Billing from "../Account/Setting/Billing";
import PopUpModal from "../../NewComponents/PopUpModal";
import CARDICON from "../../assets/icons/CardBlue.png";
import {ReactComponent as STRIPEICON } from "../../assets/icons/stripe.svg";
import PAYPAL from "../../assets/icons/paypal.png";
import "./OrderPayment.css";
import { checkAutoBilling, decrTeamFreeExpedOrder, getClientSecret, getDiscount, getTeamOwnerEmail, getTotal } from "../../Data/Functions";
import { auth, firestore, getFullHttpUrl } from "../../firebase.config";
import StripeExpressCheckout from "../../NewComponents/StripeExpressCheckout";
import ElementsWrapper from "../../NewComponents/ElementsWrapper";
import { EAST1 } from "../../utility/enums";
import { updateHowDidYouHearData } from "../../Data/Functions/HowDidYouHear";
import { gTagPurchaseEvent } from "../../Data/Functions/gTAgEvents";

const OrderPayment = ({ windowSize }) => {
  const { transitionTo } = useScreenTransition();
  const { showNotification } = useContext(NotificationContext);
  const { signedIn } = useContext(AuthContext);
  const { order, setOrder, userData, teamData } = useContext(DataContext);

  const [discountCode, setDiscountCode] = useState("");
  const [appliedCode, setAppliedCode] = useState("");
  const [discount, setDiscount] = useState(0);
  const [storedOrderId, setStoredOrderId] = useState(null);
  const [applingDiscount, setApplingDiscount] = useState(false);
  const [cardName, setCardName] = useState("");
  const [saveCard, setSaveCard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [orderSubmitButton, setOrderSubmitButton] = useState(teamData && teamData.billingTerm && teamData.billingTerm !== "case-by-case" ? "Place Order" : "Pay");
  const statusOverlayProps = useSpring({
    display: isLoading ? "flex" : "none",
  });
  const discountOverlayProps = useSpring({
    display: applingDiscount ? "flex" : "none",
  });
  const [paymentStatus, setpaymentStatus] = useState("");
  const [paymentCardId, setPaymentCardId] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [cardsList, setCardsList] = useState([]);
  const [selectedPaymentType, setSelectedPaymentType] = useState("all");
  const [autoBilling, setAutoBilling] = useState(teamData && teamData.billingTerm && teamData.billingTerm !== "case-by-case" ? true : false);

  const stripeRef = useRef(null);

  const handleStripeReady = ({stripe, elements}) => {
    stripeRef.current = {stripe, elements};
  }

  useEffect(() => {
    if (paymentStatus === "paid") {
      return;
    }
    if (
      order.parsed &&
      (order.name === "" || order.email === "") &&
      !signedIn
    ) {
      transitionTo("/order/contact");
    } else if (
      order.parsed &&
      (order.orderID === "" ||
        !order.languageFrom ||
        order.languageFrom === "" ||
        !order.languageTo ||
        order.languageTo === "" ||
        !order.files ||
        order.files.length === 0)
    ) {
      transitionTo("/order/documents");
    } else if (order.parsed && !order.optionsSet) {
      transitionTo("/order/options");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order, signedIn]);

  useEffect(() => {
    if(order.parsed){
      if(order.discount && order.discount > 0){
        setDiscount(order.discount);
      }else if(userData && userData.teamId && teamData && teamData.discount && teamData.discount > 0){
        setDiscount(teamData.discount);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, teamData, order]);

  useEffect(() => {
    if (userData && userData.teamId && teamData) {
      if (teamData.billingTerm && teamData.billingTerm !== "case-by-case") {
        setAutoBilling(true);
        setOrderSubmitButton("Place Order")
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, teamData]);

  useEffect(() => {
    if (signedIn && userData) {
      if (userData.teamId && teamData) {
        setCardsList(teamData.paymentMethods ? teamData.paymentMethods : []);
      } else {
        setCardsList(userData.paymentMethods ? userData.paymentMethods : []);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, teamData]);

  const [customerId, setCustomerId] = useState("");


  const getCustomerId = async (id, isTeam) => {
    const email = isTeam && userData ? await getTeamOwnerEmail(userData.teamId) : null;
    
    await axios({
      method: "post",
      url: getFullHttpUrl("stripe-createCustomer"),
      data: {
        name: userData ? (userData.teamId && teamData ? teamData.name : userData.name) : order.name ?? "guest",
        email: email ? email : userData ? userData.email : order.email || "",

      },
    })
      .then((res) => {
        
        if (res.data && res.data.customerId) {
          if (id) {
            if (isTeam) {
              firestore.collection("teams").doc(id).update({
                stripeCustomerId: res.data.customerId,
              });
            } else {
              firestore.collection("users").doc(id).update({
                stripeCustomerId: res.data.customerId,
              });
            }
          }
          setCustomerId(res.data.customerId);
        } else {
          setCustomerId("");
        }
      })
      .catch((e) => {
        showNotification(
          "Error",
          "There was an error. Please, try again or refresh the page.",
          "error"
        );
      });
  };

  useEffect(() => {
    if(customerId !== ""){
      return;
    }
    if (signedIn && userData) {
      if (userData.teamId && teamData) {
        if (teamData.stripeCustomerId) {
          setCustomerId(teamData.stripeCustomerId);
        } else {
          getCustomerId(userData.teamId, true);
        }
      } else {
        if (userData.stripeCustomerId) {
          setCustomerId(userData.stripeCustomerId);
        } else {
          getCustomerId(userData.id, false);
        }
      }
    } else {
      setCustomerId("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, teamData]);

  const handleSaveNewAddress = async (address) => {
    if (address) {
      
      const newAddress = { default: false, ...address };

      const mShipping = userData.teamId && teamData ? teamData.shipping ? teamData.shipping.concat([newAddress]) : [newAddress] 
      : userData.shipping ? userData.shipping.concat([newAddress]) : [newAddress];

      await firestore
        .collection(userData.teamId && teamData ? "teams" :"users")
        .doc(userData.teamId && teamData ? teamData.id : userData.id)
        .update({
          shipping: mShipping,
        })
        .then(() => { })
        .catch((error) => {
          console.log(error)
          showNotification(
            "Error",
            "An error ocurred while saving the address. Unfortunately, the address couldn't be saved.",
            "error"
          );
        });
    }
  };

   const removeUndefinedFields = (obj) => {
    if (Array.isArray(obj)) {
      return obj.map(removeUndefinedFields);
    } else if (obj !== null && typeof obj === "object") {
      return Object.fromEntries(
        Object.entries(obj)
          .filter(([_, v]) => v !== undefined) // Remove undefined fields
          .map(([k, v]) => [k, removeUndefinedFields(v)]) // Recursively clean nested objects
      );
    }
    return obj;
  };

  const handlePlaceOrder = async (paymentID) => {
    setOrderSubmitButton(autoBilling ? "Placing..." : "Paying...");
    setIsLoading(true);

    try{

    const now = new Date();

    // const addressID = uuidv4();

    const hardCopyAddress = order.hardCopy && order.hardCopyExtra;

    const saveNewAddress =
      hardCopyAddress &&
      hardCopyAddress.newAddress &&
      hardCopyAddress.saveAddress;

      const getAddress = () => {
        if (signedIn && userData && userData.teamId && teamData && teamData.shipping && teamData.shipping.length > 0 ) {
          return teamData.shipping.find((a) => a.id === hardCopyAddress.id);
         }else if (signedIn && userData && userData.shipping && userData.shipping.length > 0) {
           return userData.shipping.find((a) => a.id === hardCopyAddress.id);
         }
          return null;
        }

    const address = hardCopyAddress && hardCopyAddress.newAddress
      ? {
        id: hardCopyAddress.id,
        country: hardCopyAddress.country,
        addressName: hardCopyAddress.addressName,
        firstName: hardCopyAddress.firstName,
        lastName: hardCopyAddress.lastName,
        recipient: hardCopyAddress.firstName + " " + hardCopyAddress.lastName,
        region: hardCopyAddress.region,
        city: hardCopyAddress.city,
        zipCode: hardCopyAddress.zipCode,
        street: hardCopyAddress.street,
        apartment: hardCopyAddress.apartment,
      }
      : getAddress();

    const saveNewAddressData = saveNewAddress ? address : "";

    const storedOrderId = order.orderID;

    const data = {
        timestamp: now.getTime(),
        status: "new",
        shippingInfo: hardCopyAddress ? address : null,
        paypalOrderID: paymentID,
        discountApplied: discount > 0,
        discount: discount,
        totalPrice: getTotal(order),
        discountedPrice: getTotal(order)- getDiscount(order, false, discount),
        discountAmount: getDiscount(order, false, discount),
        discountCode: appliedCode,
    }


    const cleanData = removeUndefinedFields(data);

    await firestore
      .collection("orders")
      .doc(order.orderID)
      .update(cleanData)
      .then(async () => {
        if (signedIn && userData && saveNewAddress) {
          handleSaveNewAddress(saveNewAddressData);
        }

        if (appliedCode !== "") {
          axios({
            method: "post",
            url: getFullHttpUrl("updateCouponUsage", EAST1),
            data: {
              code: appliedCode,
            },
          }).catch((e) => { console.log(e)});
        }

    if(order.expedited || order.expeditedPlus){
      decrTeamFreeExpedOrder(order.teamId);
    }
    
    updateHowDidYouHearData(order.orderID, order.howDidYouHear, order.email, order.name, order.orderNumber);

        setOrderSubmitButton(autoBilling ? "Place Order" : "Pay");
        setpaymentStatus("paid");
        localStorage.setItem(
          "order",
          JSON.stringify({ orderID: "", name: "", email: "", parsed: true })
        );
        setOrder({ orderID: "", name: "", email: "", parsed: true });
        
        setStoredOrderId(storedOrderId);
        setShowSuccessModal(true);
        // setIsLoading(false);
      })
      .catch((e) => {
        setOrderSubmitButton(autoBilling ? "Place Order" : "Pay");
        setIsLoading(false);
        console.log(e)
        showNotification(
          "Error",
          "An error ocurred while finishing the order. Please, try again.",
          "error"
        );
      });
    }catch(e){
      setIsLoading(false);
      console.log(e)
      showNotification(
        "Error",
        "An error ocurred while finishing the order. Please, try again.",
        "error"
      );
    }finally{
      setOrderSubmitButton(autoBilling ? "Place Order" : "Pay");
      setIsLoading(false);
    }
  };

  const createOrder = (data, actions) => {
    return actions.order.create({
      intent: "CAPTURE",
      purchase_units: [
        {
          description: `Your Order`,
          amount: {
            currency_code: "USD",
            value: (
              getTotal(order) - getDiscount(order, false, discount)
            ).toFixed(2),
          },
          reference_id: order.orderID,
        },
      ],
      application_context: {
        brand_name: "eVerbary",
        landing_page: "NO_PREFERENCE",
        user_action: "PAY_NOW",
        payment_method: {
          payee_preferred: "IMMEDIATE_PAYMENT_REQUIRED",
        },
      },
    });
  };

  const onOrderApprove = async (data, actions) => {

    await actions.order.capture().then( async details => {
      setIsLoading(true); 
      gTagPurchaseEvent(order, discount);

      if (details && details.payer) {
        const paypalUserData = {
        payerID: details.payer.payer_id,
        email: details.payer.email_address,
        name: `${details.payer.name.given_name} ${details.payer.name.surname}`,
      };

      try {
        if(!signedIn || !auth.currentUser){
          return;
        }
        const userRef = firestore
          .collection("users")
          .doc(auth.currentUser.uid);

        // Fetch the existing PaypalData field
        const userDoc = await userRef.get();

        let existingData = [];
        if (userDoc.exists) {
          const data = userDoc.data();
          existingData = Array.isArray(data.PaypalData) ? data.PaypalData : [];
        }

        // Check if payerID already exists
        const isDuplicate = existingData.some(
          (item) => item.payerID === paypalUserData.payerID
        );

        if (!isDuplicate) {
          // Add new data if payerID is not a duplicate
          existingData.push(paypalUserData);

          // Update Firestore
          await userRef.update({ PaypalData: existingData });

          showNotification(
            "Information Saved",
            "PayPal data successfully added.",
            "success"
          );
          // } else {
          //     showNotification(
          //         "Information Unchanged",
          //         "This PayPal account is already linked.",
          //         "info"
          //     );
        }
      } catch (error) {
        console.log("Error updating PayPal data:", error);
        showNotification("Error", "Error updating PayPal data", "error");
      }
    }

    setIsLoading(true);
    handlePlaceOrder(data.orderID);

    })
  };

  const onOrderPaymentFailure = (data, actions) => {
    setIsLoading(false);
    showNotification(
      "Error",
      "An error ocurred while placing the order. Please, try again.",
      "error"
    );
  };

  const handleApplyCode = () => {
    setApplingDiscount(true);
    
    try {
      firestore
        .collection("coupons")
        .where("code", "==", discountCode)
        .get()
        .then((querySnapshot) => {
          if (querySnapshot.docs.length > 0) {
            const doc = querySnapshot.docs[0];

            if (doc.data().uses > 0) {
              setDiscount(doc.data().discount);
              setAppliedCode(discountCode);
            } else {
              showNotification(
                "Error",
                "That code is no longer valid. Please, try another one.",
                "error"
              );
            }
          } else {
            showNotification(
              "Error",
              "That code doesn't exist. Please, try another one.",
              "error"
            );
          }
        });
    } catch (e) {
      showNotification(
        "Error",
        "There was an error applying the code. Please, try again.",
        "error"
      );
    } finally {
      setTimeout(() => {
        setApplingDiscount(false);
      }, 500);
    }
  };

  const phoneScreen =
    windowSize.orientation === "portrait" && windowSize.width <= 767;

  const handleSaveCard = async (result) => {

    // status: "requires_action"
    // processing: null
    // cancelled at
    // last_payment_error

    if (result.error) {
      console.log("error",result.error)
      showNotification("Error", result.error.message, "error");
      setOrderSubmitButton("Pay");
      setIsLoading(false);
      return;
    } else if(result.paymentIntent){
      const { payment_method: paymentMethodId, id, last_payment_error, status } = result.paymentIntent;

      if (last_payment_error) {
        console.log("error",last_payment_error.message)
        showNotification("Error", last_payment_error.message, "error");
        setOrderSubmitButton("Pay");
        setIsLoading(false);
        return;
      } 

      if (saveCard && paymentCardId === "") {
        if (customerId) {
          await axios({
            method: "post",
            url: getFullHttpUrl("stripe-attachPaymentMethodToCustomer"),
            data: {
              customerId: customerId,
              paymentMethodId: paymentMethodId,
            },
          }).then((res) => {
            
            const defaultCard = cardsList.length === 0 ? true : false;
            const methodDetails = res.data.paymentMethod;

            firestore
              .collection(userData.teamId ? "teams" : "users")
              .doc(userData.teamId ? userData.teamId : userData.id)
              .update({
                paymentMethods: [
                  ...cardsList,
                  {
                    default: defaultCard,
                    card: methodDetails.card,
                    id: methodDetails.id,
                    billing_details: methodDetails.billing_details,
                    customer: methodDetails.customer
                  },
                ],
              });
          });
        }
      }
      if(status === "succeeded"){
        gTagPurchaseEvent(order, discount);
        handlePlaceOrder(id);
      }else{
        setOrderSubmitButton("Pay");
        setIsLoading(false);
        return;
      }
    }

  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if(autoBilling){
      handlePlaceOrder("auto-billing");
      return;
    }

    if (selectedPaymentType === "pay-later") {
      handlePlaceOrder("pay-later");
      return;
    }

    const {stripe, elements} = stripeRef.current || {};
    if (!stripe || !elements) {
      showNotification(
        "Error",
        "There was an error. Please, try again or refresh the page.",
        "error"
      );
      return;
    }
    
    setIsLoading(true);
    setOrderSubmitButton("Paying...");

    const cardEelment = elements.getElement(CardNumberElement);
    const amount = getTotal(order)- getDiscount(order, false, discount);

    try {
      if(selectedPaymentType === "card"){
         await getClientSecret("order", order, order.orderNumber, userData ? userData.email : order.email, amount, order.orderID, userData, teamData, paymentCardId).then(async client_secret =>{

          if(!client_secret){
            showNotification("Error", "There was an error. Please, try again or refresh the page.", "error");
            setOrderSubmitButton("Pay");
            setIsLoading(false);
            return;
          }

          paymentCardId
          ? await stripe.confirmCardPayment(client_secret, {
            payment_method: paymentCardId,
          }).then(result => handleSaveCard(result))
          : await stripe.confirmCardPayment(client_secret, {
            payment_method: {
              card: cardEelment,
              billing_details: {
                name: cardName,
              },
            },
            setup_future_usage: "off_session",
          }).then(result => handleSaveCard(result))
        })
      }else if(selectedPaymentType === "all"){
        await stripe.confirmPayment({
          elements,
          redirect: "if_required",
          confirmParams: {
            return_url: `http://localhost:3000/account/order/${order.id}`
          }
        }).then(result => handleSaveCard(result))
      }
     
    } catch (e) {
      console.log(e)
      setOrderSubmitButton("Pay");
      setIsLoading(false);
      showNotification(
        "Error",
        "There was an error. Please, try again or refresh the page.",
        "error"
      );
    }finally{
      setOrderSubmitButton("Pay");
      setIsLoading(false);
    }
  };

  const handlePopUpClick = (e) => {
    setIsLoading(false);
    if (storedOrderId) {
      transitionTo(`/account/order/${storedOrderId}`, e); // Use stored order ID
      setShowSuccessModal(false);
      setStoredOrderId(null);
    } else {
      transitionTo("/", e);
      setShowSuccessModal(false);
    }
  };

  // const PayPalBillingButtons = () => {
  //   return (
  //     <PayPalButtons
  //       createOrder={createOrder}
  //       onApprove={onOrderApprove}
  //       onError={onOrderPaymentFailure}
  //       onShippingChange={function noRef() { }}
  //     />
  //   );
  // };

  // const PayPalBillingAgreement = () => {
  //   const [showPayPalButtons, setShowPayPalButtons] = useState(false);
  //   const [{ isPending }] = usePayPalScriptReducer();

  //   return (
  //     <div>
  //       {!showPayPalButtons ? (
  //         <button
  //           className="bg-[#0070ba] text-white border-none rounded-[20px] px-5 py-2 text-[16px] flex items-center gap-2 cursor-pointer"
  //           onClick={() => setShowPayPalButtons(true)}
  //         >
  //           <PAYPALICON />
  //           Continue with PayPal
  //         </button>
  //       ) : (
  //         <div className="mt-4">
  //           {isPending ? <p>Loading PayPal<span className="dotsLoading">...</span></p> : <PayPalBillingButtons />}
  //         </div>
  //       )}
  //     </div>
  //   );
  // };

  return (
    <>
      <animated.div
        style={statusOverlayProps}
        className="checkoutStatusOverlay"
      >
        We are finishing up the order and redirecting you. This will take a
        second<span className="dotsLoading">...</span>
      </animated.div>
      <animated.div
        style={discountOverlayProps}
        className="checkoutStatusOverlay"
      >
        Applying Discount, Please wait...
      </animated.div>

      {showSuccessModal && (
        <PopUpModal
          title="Order Placed"
          btnText="Go to Order"
          onClick={(e) => handlePopUpClick(e)}
          text={ autoBilling ? "Order will be paid at the end of billing term, you can track its progress on the Order page in your account." : 
            "You can track its progress on the Orders page in your account."
          }
        >
          <ORDERSUCCESS />
        </PopUpModal>
      )}

      <TopBar />

      <div className="mainOrderContainer">
        <div className="mainOrderHeader">
          <LogoAuthNavbar isAuth={signedIn} showButtons={false} />
        </div>
        <div className="mainOrderPageContainer">
          <div className="mainOrderPageContainerOptions">
            <CreateOrderNav title="5. Choose Payment Method" stage={5} />
            <div></div>
          </div>
        </div>
        <div className="mainOrderPageContainer">
          <div className="mainOrderPageContainerOptions">
            <div id="mainPrimary" className="mainOrderPrimaryContent">
              {autoBilling ?
              <div className="quotePrimaryOptionsWrapper orderPaymentOptionWrapper">
                <div className="autobillingWarningOverlay">
                  <p className=" mainSecureAndPrivateText w-[80%] font-[600]">
                  Your team is billed on a {teamData &&  teamData.billingTerm && teamData.billingTerm === "own" ? "personalized" : teamData.billingTerm || ""} basis. 
                  You will receive a single invoice summarizing all orders placed during this period. Orders cannot be paid for separately. 
                  If you prefer to pay per order, you can change your payment approach by going to 
                  <span style={{fontWeight: 600, cursor: "pointer"}} onClick={() => {window.open("/account/settings", "_blank")}}> Account Settings → Billing</span>.
                  </p>
                </div>

                <h4 className="quotePrimaryTitle">Payment Methods</h4>

                {!isLoading && <div className="flex justify-start items-center gap-3">
                  {<div
                    className={`caseByCaseBtn billingPeriodBtn ${selectedPaymentType === "card" && "selectedBillingTerm"
                      }`}
                    onClick={() => {
                      setSelectedPaymentType("all");
                      setOrderSubmitButton("Pay");
                    }}
                  >
                    {/* <img
                      className="orderPaypalIcon"
                      src={CARDICON}
                      alt="all"
                    /> */}
                    All
                  </div>}
                </div>}

              </div> :
              <div className="quotePrimaryOptionsWrapper orderPaymentOptionWrapper">
                
                <h4 className="quotePrimaryTitle">Payment Methods</h4>

                {!isLoading && <div className="paymentMethodWrapper flex justify-start items-center gap-3">
                  <div
                    className={`caseByCaseBtn billingPeriodBtn ${selectedPaymentType === "all" && "selectedBillingTerm"
                      }`}
                    onClick={() => {
                      setSelectedPaymentType("all");
                      setOrderSubmitButton("Pay");
                    }}
                  >
                    {/* <img
                      className="orderPaypalIcon"
                      src={STRIPEICON}
                      alt="stripe"
                    /> */}
                    <STRIPEICON className="orderPaypalIcon"/>
                  </div>
                  
                  <div
                    className={`caseByCaseBtn billingPeriodBtn ${selectedPaymentType === "paypal" && "selectedBillingTerm"
                      }`}
                    onClick={() => setSelectedPaymentType("paypal")}
                  >
                    <img className="orderPaypalIcon" src={PAYPAL} alt="paypal" />
                  </div>
                  {cardsList.length > 0 && <div
                    className={`caseByCaseBtn billingPeriodBtn ${selectedPaymentType === "card" && "selectedBillingTerm"
                      }`}
                    onClick={() => {
                      setSelectedPaymentType("card");
                      setOrderSubmitButton("Pay");
                    }}
                  >
                    <img
                      className="orderPaypalIcon"
                      src={CARDICON}
                      alt="card"
                    />
                    Saved Cards
                  </div>}

                  {(userData && userData.teamId && teamData && !checkAutoBilling(teamData)) 
                  || (!signedIn && order && order.type === "business") ? (
                    <div
                      className={`caseByCaseBtn billingPeriodBtn ${selectedPaymentType === "pay-later" &&
                        "selectedBillingTerm"
                        }`}
                      onClick={() => {
                        setSelectedPaymentType("pay-later");
                        setOrderSubmitButton("Pay Later");
                      }}
                    >
                      <img
                        className="orderPaypalIcon"
                        src={CARDICON}
                        alt="card"
                      />
                      Pay Later
                    </div>
                  ) : ""}
                </div>}

                {
                selectedPaymentType === "all" && !showSuccessModal && order.parsed && (
                  <StripeExpressCheckout  type={"order"} number={order.orderNumber} amount={getTotal(order)- getDiscount(order, false, discount)} item={order}
                  id={order.orderID} discount={discount} onStripeReady={handleStripeReady} setSaveCard={setSaveCard} saveCard={saveCard}/>
                )}

                {selectedPaymentType === "card" && (
                  <ElementsWrapper>
                    <Billing
                      setSelectedCard={setPaymentCardId}
                      selectedCard={paymentCardId}
                      setCardOwner={setCardName}
                      cardOwner={cardName}
                      saveCard={saveCard}
                      setSaveCard={setSaveCard}
                      cardsList={cardsList}
                      setCardsList={setCardsList}
                      showNewCard={false}
                      onStripeReady={handleStripeReady}
                      />
                  </ElementsWrapper>
                )}

                {selectedPaymentType === "pay-later" && (
                  <div className="grid gap-4 text-start p-3 w-full">
                    {signedIn ?
                     <p className="mainSecureAndPrivateText">
                      To proceed with the Pay-Later option, simply select "Pay" button. <br/>
                      Your order will be placed immediately, and you'll be able to complete your payment later.
                    </p> :
                     <p className="mainSecureAndPrivateText">
                      To access the Pay-Later option, you need to create a business account. <br/><br/>
                      With Pay-Later option, Your order will be placed immediately and you'll be able to complete your payment later.
                    </p>
                    }
                  </div>
                )}

                {selectedPaymentType === "paypal" && (
                  <div className="grid gap-4 text-start p-3 w-full">
                    <p className="text-[#686F7B] max-w-screen-sm font-normal">
                      To proceed with your payment, please click on the "PayPal"
                      button. A PayPal page will open where you can securely
                      complete your transaction. Please follow the instructions
                      on the PayPal page to finalize your payment.
                    </p>
{/* 
                    <h3 className="text-[#030F23] font-semibold text-lg font-secondary">
                      Connect to PayPal
                    </h3>

                    <p className="text-[#686F7B] max-w-screen-sm font-normal">
                      Connecting to PayPal will simplify and speed up future
                      payment processes by eliminating the need to re-enter
                      payment information with every purchase.
                    </p>

                    <PayPalBillingAgreement /> */}
                  </div>
                )}
              </div>
              }
              <div className="quotePrimaryOptionsWrapper">
                <h4 className="quotePrimaryTitle">Discount Code</h4>
                <div className="orderDiscountCodeWrapper">
                  <FormTextInput
                    placeholder={"Discount code"}
                    value={discountCode}
                    onChange={setDiscountCode}
                    discountIcon={discount > 0}
                    discountIconText={`${discount}%`}
                  />
                  <NewButton
                    text={"Apply"}
                    back={true}
                    icon={false}
                    onClick={() => handleApplyCode()}
                    whiteBtn={true}
                  />
                </div>
              </div>

              <div>
                {!phoneScreen && (
                  <div className="quoteSubmitButtonContainer leftQuoteSubmitButtonContainer ">
                    <NewButton
                      text={"Back to Contact"}
                      onClick={(e) => transitionTo("/order/contact", e)}
                      back={true}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="mainOrderSecondaryContent">
            <div className="mainOrderSecondaryContentWrap">
              <OrderSummary
                order={order}
                certified={order.certified}
                pagesCount={order.pagesCount}
                languageFrom={order.languageFrom}
                languageTo={order.languageTo}
                discount={discount}
                showBtn={
                  ((selectedPaymentType === "card" || selectedPaymentType === "all") && ((getTotal(order)- getDiscount(order, false, discount)) >= 1)) ||
                  (signedIn && selectedPaymentType === "pay-later")
                }
                handleBtnSubmit={handleSubmit}
                // handleBtnSubmit={handleSubmit}
                btnText={orderSubmitButton}
                disableBtn={isLoading}
                paypalBtn={selectedPaymentType === "paypal" && ((getTotal(order)- getDiscount(order, false, discount)) > 0)}
                windowSize={windowSize}
                createOrder={createOrder}
                onApprove={onOrderApprove}
                onError={onOrderPaymentFailure}
                totalWarning={((selectedPaymentType === "card" || selectedPaymentType === "all") && ((getTotal(order)- getDiscount(order, false, discount)) < 1)) || (selectedPaymentType === "paypal" && ((getTotal(order)- getDiscount(order, false, discount)) <= 0))}
              />
              <div>
                <SecureAndPrivate order={order}/>
                {phoneScreen && (
                  <div className="quoteSubmitButtonContainer">
                    <NewButton
                      text="Back to Contact"
                      onClick={(e) => transitionTo("/order/contact", e)}
                      back={true}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderPayment;
